import type { FC } from "react";
import { getEnvironment } from "../helpers/environment";
import styles from "./DevProdBanner.module.css";

const isLocalhost = (): boolean => {
  const host = globalThis.location?.hostname ?? "";
  return ["localhost", "127.0.0.1", "nginx"].some((h) => host.includes(h));
};

/** Warns the developer when the local container is pointed at production data. */
export const DevProdBanner: FC = () => {
  if (!isLocalhost() || getEnvironment() !== "production") return;

  return (
    <div className={styles.banner} data-qa="DevProdBanner" role="alert">
      <span className={styles.label}>
        Using PROD DATA — Beware, writes you make will hit Prod Env.
      </span>
    </div>
  );
};

export default DevProdBanner;
